import { FCC, ZazumeFormProvider } from '@zazume/zzm-base';
import { createContext, useContext } from 'react';
import { FormProvider, useFormContext, UseFormMethods } from 'old-rhf';
import { useForm } from 'react-hook-form';


interface ZazumeFormContextReturn extends UseFormMethods {
  inlineErrors: boolean;
}

const ZazumeFormContext = createContext<ZazumeFormContextReturn | null>(null);

export const oldUseZazumeFormContext = () => {
  const context = useContext(ZazumeFormContext);
  if (!context) {
    throw new Error('ZazumeFormContext must be used within ZazumeFormProvider!');
  }
  return context;
};

interface ZazumeFormProviderProps {
  form: any;
  inlineErrors: boolean;
}

/**
 * @deprecated Temporal fix to avoid zzm-base component updated with new react-hook version
 */
export const OldZazumeFormProvider: FCC<ZazumeFormProviderProps> = ({ form, inlineErrors, children }) => {
  const internalForm = useForm();

  return (
    <FormProvider {...form}>
      <ZazumeFormProvider form={internalForm} inlineErrors={inlineErrors}>
        <ProviderWrapper inlineErrors={inlineErrors}>{children}</ProviderWrapper>
      </ZazumeFormProvider>
    </FormProvider>
  );
};

interface ProviderWrapperProps {
  inlineErrors: boolean;
}

const ProviderWrapper: FCC<ProviderWrapperProps> = ({ inlineErrors, children }) => {
  const context = useFormContext();

  return <ZazumeFormContext.Provider value={{ inlineErrors, ...context }}>{children}</ZazumeFormContext.Provider>;
};
